interface ContactUsButtonProps {
    buttonText: string
}

export const Button = ({ buttonText }: ContactUsButtonProps) => {
    return (
        <button
            type="button"
            className="bg-gradient-to-r from-green-400 to-green-600 text-white py-3 px-4 rounded-lg 
            hover:from-green-500 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 
            focus:ring-offset-2 transition-all duration-300 disabled:opacity-70"
        >
            {buttonText}
        </button>
    );
};